import { render, staticRenderFns } from "./Update-Order.vue?vue&type=template&id=ad659da2"
import script from "./Update-Order.vue?vue&type=script&lang=js"
export * from "./Update-Order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports